import { render, staticRenderFns } from "./IntegrationManage.vue?vue&type=template&id=30859244&scoped=true&"
import script from "./IntegrationManage.vue?vue&type=script&lang=js&"
export * from "./IntegrationManage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationManage.vue?vue&type=style&index=0&id=30859244&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30859244",
  null
  
)

export default component.exports